import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalComponent } from "@shared/components/modal/modal.component";
import { ToastComponent } from "@shared/components/toast/toast.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalComponent, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected title = 'leilao-dnpe';
}
